import Cookies from 'js-cookie';
import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';
import { DefaultLink } from '@hivebrite/design-system/Link';

import { setAuthAttempt } from 'hb-react/publicoffice/apps/LoginApp//utils/authAttemptSessionStorage';
import { getProviderStyle } from 'hb-react/publicoffice/apps/LoginApp/utils/getProviderStyle';
import { getSocialProviderEnabled } from 'hb-react/publicoffice/apps/LoginApp/utils/getSocialProviderEnabled';

const LoginSocial = ({ settings, origin }) => {
  const { enabled, providers } = settings;

  return (
    enabled &&
    providers.filter(getSocialProviderEnabled).map((provider) => {
      const url = new URL(provider.url);
      const { label, ...providerStyle } = getProviderStyle(provider);

      if (origin) {
        url.searchParams.append('origin', origin);
      }

      return (
        <DefaultLink key={provider.provider} href={url.toString()}>
          <CustomButton
            {...providerStyle}
            onClick={() => {
              const cookiesConsentListData = Cookies.get(
                'cookie_consent_list_fo',
              );

              if (cookiesConsentListData) {
                const cookiesConsentList = JSON.parse(cookiesConsentListData);

                if (
                  cookiesConsentList.tracking?.find(
                    (cookie) => cookie.name === 'Google analytics',
                  )?.accepted
                ) {
                  Cookies.set('login_method', provider.provider, {
                    expires: 1,
                  });
                }
              }
              setAuthAttempt(provider.provider);
            }}
          >
            {label}
          </CustomButton>
        </DefaultLink>
      );
    })
  );
};

export default LoginSocial;

const CustomButton = styled(Button)`
  box-shadow: ${(props) =>
    props.variant === 'secondary' ? '0 1px 6px 0 rgba(0,0,0,0.1)' : 'inherit'};
  height: 36px;
  margin-bottom: 12px;
  margin-top: 12px;
  width: 100%;
  &:hover {
    fill: ${(props) => (props.name === 'Apple' ? props.theme.bg : 'inherit')};
  }
`;
